import React, { useState } from "react";
import { Chart } from "react-google-charts";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomBox = styled(Box)(({ topColor, bottomColor }) => ({
  display: "flex",
  flexDirection: "column",
  width: "150px",
  height: "65px",
  borderRadius: "12px",
  border: "1px solid grey",
  overflow: "hidden",
  boxShadow: "none",
  color: "#fff",
  position: "relative",
  backgroundColor: topColor,
  "&::before": {
    content: '""',
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "55%",
    backgroundColor: bottomColor,
  },
  "& > div": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    zIndex: 1,
    position: "relative",
    padding: "10px",
    textAlign: "center",
  },
  "& .label": {
    fontSize: "1rem",
    fontWeight: 600,
    color: "black",
    marginBottom: "15px",
  },
  "& .count": {
    fontSize: "1rem",
    fontWeight: 800,
    marginBottom: "4px",
  },
}));

const ReportBar = ({ bardata, options, clickData, onClick }) => {
  const [visibleSlices, setVisibleSlices] = useState(new Array(bardata.filter(a => a[2]).length).fill(true));

  const graphData = [bardata[0].slice(0,2)].concat(bardata.filter(a => a[2]).map(a => a.slice(0,2)));

  const legendData = bardata.slice(1).map(([status, count], index) => ({
    label: status,
    count,
    color: options.colors[index],
    click: onClick,
  }));

  return (
    <div className="d-sm-flex d-block justify-content-end align-items-center mb-2">
      <div className="w-100 h-100 d-none d-sm-block">
        <Chart chartType="PieChart" width="90%" height="550px" data={graphData} options={{ ...options, colors: options.colors.slice(1) }} />
      </div>
      <div className="w-100 d-block d-sm-none">
        <Chart chartType="PieChart" width="100%" height="200px" data={graphData} options={{ ...options, colors: options.colors.slice(1) }} />
      </div>

      <div className="d-flex flex-column justify-content-center align-items-center">
        {legendData.map(({ label, count, color, click }, index) => (
          <CustomBox className="my-1 my-sm-3 w-100 w-sm-* clickable" key={index} topColor="#ffffff" bottomColor={color}>
            <div onClick={() => click({ listmode: clickData[index], label: label })}>
              <Typography className="label" style={{width: '200px'}} variant="body2">
                {label}
              </Typography>
              <Typography className="count" variant="body2">
                {count}
              </Typography>
            </div>
          </CustomBox>
        ))}
      </div>
    </div>
  );
};

export default ReportBar;
